import ko from 'knockout';

function ImageViewModel(image) {
    this.type = ko.observable(image.type);
    this.url = ko.observable(image.url);
    this.text = ko.observable(image.text);
    this.attributes = {};
    this.attributeString = ko.observable('');

    var attributeValues = [];

    if (image.attributes) {
        Object.keys(image.attributes).forEach(
            function(key) {
                this.attributes[key] = ko.observable(image.attributes[key]);
                attributeValues.push(image.attributes[key]);
            }.bind(this)
        );

        this.attributeString(attributeValues.join(', '));
    }
}

export default ImageViewModel;
